<template>
  <RareDiseaseView icd="E75.2F"
                   icd-presentation-string="E75.2F"
                   icd-description="Fabry disease"
                   disease-description="Fabry disease"
                   :mesh-ids="['D000795']"
                   mesh-description="Fabry Disease">
  </RareDiseaseView>
</template>

<script>
import RareDiseaseView from '@/components/RareDiseaseView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'fabry-page',
  components: {
    RareDiseaseView
  }
});
</script>
